import React, { useState } from "react";
import { Container, Row, Col, Input, Label, Button, Form, FormGroup, InputGroup } from "reactstrap";
import styles from "./PushNotificationsCreation.module.scss";
import FormInput from "../../../../common/AdminCommonComponents/FormInput/FormInput";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import ComponentBackButton from "../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton";

const PushNotificationsCreation = ({ setIsOpen }) => {
    const [formData, setFormData] = useState({
        title: "",
        notificationType: "",
        description: "",
        schedule: "immediate",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    const targetAudienceOptions = [
        { label: "All Users", value: "allUsers" },
        { label: "Sellers", value: "sellers" },
        { label: "Retailers", value: "retailers" },
        { label: "Wholesalers", value: "wholesalers" },
        { label: "Buyers", value: "buyers" },
        { label: "New Users", value: "newUsers" },
        { label: "Inactive Users", value: "inactiveUsers" },
    ];

    const platformOptions = [
        { label: "All", value: "all" },
        { label: "Website", value: "website" },
        { label: "Mobile Web", value: "mobileWeb" },
        { label: "Mobile App", value: "mobileApp" },
    ];

    const timeZoneOptions = [
        { label: "UTC (Universal Coordinated Time)", value: "utc" },
        { label: "GMT (Greenwich Mean Time)", value: "gmt" },
        { label: "PST (Pacific Standard Time)", value: "pst" },
        { label: "EST (Eastern Standard Time)", value: "est" },
        { label: "CST (Central Standard Time)", value: "cst" },
        { label: "IST (Indian Standard Time)", value: "ist" },
        { label: "PKT (Pakistan Standard Time)", value: "pkt" },
    ];

    const frequencyOptions = [
        { label: "Daily", value: "daily" },
        { label: "Weekly", value: "weekly" },
        { label: "Bi-Weekly", value: "biWeekly" },
        { label: "Monthly", value: "monthly" },
        { label: "Custom", value: "custom" },
    ];

    const expiryTimeOptions = [
        { label: "Option 1", value: "option1" },
        { label: "Option 2", value: "option2" },
        { label: "Option 3", value: "option3" },
    ];

    const deliveryModeOptions = [
        { label: "Option 1", value: "option1" },
        { label: "Option 2", value: "option2" },
        { label: "Option 3", value: "option3" },
    ];

    return (
        <Container fluid className={styles.notificationContainer}>
            <ComponentBackButton onClick={() => setIsOpen(false)} />
            <h4 className={styles.mainHeading}>Push Notification Creation</h4>

            <Form>
                {/* Notification Details */}
                <div className={styles.section}>
                    <h4 className={styles.sectionHeading}>Notification Details</h4>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Title"
                                type="text"
                                placeholder="Add Title"
                                id="title"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="Notification type"
                                type="text"
                                placeholder="Add Notification type"
                                id="notificationType"
                                name="notificationType"
                                value={formData.notificationType}
                                onChange={handleChange}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Media Attachment"
                                type="file"
                                placeholder="Attach media"
                                id="media"
                                name="media"
                                value={formData.media}
                                onChange={handleChange}
                                allowedTypes={["*"]}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="Description"
                                type="text"
                                placeholder="Add Description"
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                            />
                        </Col>
                    </Row>
                </div>

                {/* Target Audience */}
                <div className={styles.section}>
                    <h4 className={styles.sectionHeading}>Target Audience</h4>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Select Target Audience"
                                type="select"
                                placeholder="Select Target Audience"
                                id="targetAudience"
                                name="targetAudience"
                                value={formData.targetAudience}
                                onChange={handleChange}
                                options={targetAudienceOptions}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="Select Platform"
                                type="select"
                                placeholder="Select Platform"
                                id="platform"
                                name="platform"
                                value={formData.platform}
                                onChange={handleChange}
                                options={platformOptions}
                            />
                        </Col>
                    </Row>
                </div>

                {/* Scheduling Options */}
                <div className={styles.section}>
                    <h4 className={styles.sectionHeading}>Scheduling Options</h4>

                    <FormGroup className={styles.radioContainer}>
                        <Label className={styles.radioLabel}>
                            <Input
                                type="radio"
                                id="schedule"
                                name="schedule"
                                value="immediate"
                                checked={formData.schedule === "immediate"}
                                onChange={handleChange}
                            />
                            <span className={styles.radioCustom}></span> Send Immediately
                        </Label>
                    </FormGroup>

                    <FormGroup className={styles.radioContainer}>
                        <Label className={styles.radioLabel}>
                            <Input
                                type="radio"
                                id="schedule"
                                name="schedule"
                                value="later"
                                checked={formData.schedule === "later"}
                                onChange={handleChange}
                            />
                            <span className={styles.radioCustom}></span> Schedule for later
                        </Label>
                    </FormGroup>

                    {formData.schedule === "later" && (
                        <Row className="g-0">
                            <Col lg={6} className="ps-4 pe-lg-3">
                                <FormInput
                                    type="select"
                                    placeholder="Select Time Zone"
                                    id="timeZone"
                                    name="timeZone"
                                    value={formData.timeZone}
                                    onChange={handleChange}
                                    disabled={formData.schedule !== "later"}
                                    options={timeZoneOptions}
                                />
                            </Col>
                            <Col lg={3} className="ps-4 ps-lg-3 pe-lg-3">
                                <FormInput
                                    type="time"
                                    placeholder="Select Time"
                                    id="laterTime"
                                    name="laterTime"
                                    value={formData.laterTime}
                                    onChange={handleChange}
                                    disabled={formData.schedule !== "later"}
                                />
                            </Col>
                            <Col lg={3} className="ps-4 ps-lg-3">
                                <FormInput
                                    type="date"
                                    placeholder="Select Date"
                                    id="laterDate"
                                    name="laterDate"
                                    value={formData.laterDate}
                                    onChange={handleChange}
                                    disabled={formData.schedule !== "later"}
                                />
                            </Col>
                        </Row>
                    )}

                    <FormGroup className={styles.radioContainer}>
                        <Label className={styles.radioLabel}>
                            <Input
                                type="radio"
                                id="schedule"
                                name="schedule"
                                value="recurring"
                                checked={formData.schedule === "recurring"}
                                onChange={handleChange}
                            />
                            <span className={styles.radioCustom}></span> Recurring Notification
                        </Label>
                    </FormGroup>

                    {formData.schedule === "recurring" && (
                        <Row className="g-0">
                            <Col lg={6} className="ps-4 pe-lg-3">
                                <FormInput
                                    type="select"
                                    placeholder="Select Frequency"
                                    id="frequency"
                                    name="frequency"
                                    value={formData.frequency}
                                    onChange={handleChange}
                                    disabled={formData.schedule !== "recurring"}
                                    options={frequencyOptions}
                                />
                            </Col>
                            <Col lg={6} className="ps-4 ps-lg-3">
                                <FormInput
                                    type="date"
                                    placeholder="Select End date"
                                    id="recurringEndDate"
                                    name="recurringEndDate"
                                    value={formData.recurringEndDate}
                                    onChange={handleChange}
                                    disabled={formData.schedule !== "recurring"}
                                />
                            </Col>
                        </Row>
                    )}

                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Notification Expiry time"
                                type="select"
                                placeholder="Select Notification Expiry time"
                                id="notificationExpiryTime"
                                name="notificationExpiryTime"
                                value={formData.notificationExpiryTime}
                                onChange={handleChange}
                                options={expiryTimeOptions}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="Delivery Mode"
                                type="select"
                                placeholder="Select Delivery Mode"
                                id="deliveryMode"
                                name="deliveryMode"
                                value={formData.deliveryMode}
                                onChange={handleChange}
                                options={deliveryModeOptions}
                            />
                        </Col>
                    </Row>
                </div>

                {/* Action Buttons */}
                <div className={styles.section}>
                    <h4 className={styles.sectionHeading}>Action Buttons</h4>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Label (Optional)"
                                type="text"
                                placeholder="Primary action"
                                id="optionalLabel"
                                name="optionalLabel"
                                value={formData.optionalLabel}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="URL"
                                type="text"
                                placeholder="Destination link"
                                id="url"
                                name="url"
                                value={formData.url}
                                onChange={handleChange}
                            />
                        </Col>
                    </Row>
                    <Row className="g-0 row-gap-3">
                        <Col lg={6} className="pe-lg-3">
                            <p className={styles.previewHeading}>Preview</p>
                            <div className={styles.previewBox}></div>
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <div className={styles.testNotificationBtnContainer}>
                                <div>
                                    <Label for="test" className={styles.testLabel}>Test Notification</Label>
                                    <InputGroup className={styles.testContainer}>
                                        <Input type="text" id="test" name="test" value={formData.testUserId} placeholder="User ID" className={styles.testInput} />
                                        <Button type="button" color="secondary" className={styles.testBtn}>Test</Button>
                                    </InputGroup>
                                </div>
                                <div className={styles.btnContainer}>
                                    <DynamicButton theme="blue">Submit</DynamicButton>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Form>
        </Container>
    );
};

export default PushNotificationsCreation;